import React, { Component } from 'react';
import { Map, GoogleApiWrapper, InfoWindow, Marker } from 'google-maps-react';

const mapStyles = {
  width: '100%',
  height: '100%'
};

export class MapContainer extends Component {

  constructor(props){
    super(props)

    this.state = {
      points: [],
      showingInfoWindow: false,  //Hides or the shows the infoWindow
      activeMarker: {},          //Shows the active marker upon click
      selectedPlace: {}          //Shows the infoWindow to the selected place upon a marker
    }

    this.onMarkerClick = this.onMarkerClick.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  componentDidMount(){
    fetch('https://www.serasaconsumidor.com.br/serasaitinerante/manager/api/v1/points')
        .then(response => response.json())
        .then(data => {
          this.setState({ points: data });
        });
  }

  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  }

  onClose = props => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      });
    }
  };

  render() {

    const itens = this.state.points.map((item) => {
        var image = process.env.PUBLIC_URL + "/images/icons/active-pin.png";
                return (
                  <Marker
                    onClick={this.onMarkerClick}
                    name={item.name}
                    period={item.period}
                    location={item.location}
                    position = {{ lat: item.lat, lng: item.lng }}
                    key={item.id}
                    icon={image}
                  />
                )
              })

    return (
      <Map
        google={this.props.google}
        zoom={4}
        style={mapStyles}
        initialCenter = {{ lat: -23.6821604, lng: -46.8754899 }}
      >

      { itens }

      <InfoWindow
        marker={this.state.activeMarker}
        visible={this.state.showingInfoWindow}
        onClose={this.onClose}
      >
        <div>
          <h3 className="c-title c-title--size-small c-title--weight-bold c-title--color-purple" >{this.state.selectedPlace.name}</h3>
          <p className="c-title c-title--size-small c-title--color-purple">{this.state.selectedPlace.location} de <b>{this.state.selectedPlace.period}</b></p>
        </div>
      </InfoWindow>

      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyCDwVTlAPbq4gxnSpjjAHTbKv2W31tKmKs'
})(MapContainer);


// WEBPACK FOOTER //
// ./src/components/MapContainer.js